module.exports = __webpack_public_path__ + "img/badge_gray_pop-research.05c29f56.svg";